<template>
  <v-container>
    <VWidget :title="$t('transfer_title_transfer')" :loading="loading" fluid>
      <template v-slot:content>
        <v-tabs active-class="tab-active">
          <v-tab>
            {{ $t('transfer_title_transfer_actives') }}
          </v-tab>
          <v-tab>
            {{ $t('transfer_title_transfer_history') }}
          </v-tab>
          <v-tab-item class="my-6">
            <actives :items="actives" />
          </v-tab-item>
          <v-tab-item class="my-6">
            <historics :items="historics" />
          </v-tab-item>
        </v-tabs>
      </template>
    </VWidget>
  </v-container>
</template>
<script>
import VWidget from '@/components/commons/VWidget'
import Actives from './partials/Actives'
import Historics from './partials/Historics'
import SecurityTransferRequestService from '../../services/securityTransferRequest'
import { mapState } from 'vuex'

export default {
  components: {
    VWidget,
    Actives,
    Historics
  },
  data() {
    return {
      loading: false,
      actives: [],
      historics: []
    }
  },
  computed: {
    ...mapState('account', ['account']),
    ...mapState('auth', ['user'])
  },
  async created() {
    await this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      try {
        const data = await SecurityTransferRequestService.find(
          this.account.code
        )
        this.actives = data.filter(item => item.isActive)
        this.historics = data.filter(item => !item.isActive)
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-button {
  width: 208px;
  min-width: 130px !important;
  background: transparent linear-gradient(112deg, #00559e 0%, #0090df 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 6px 10px 14px #00000029;
  border-radius: 28px;
  opacity: 1;
}
.v-tab {
  text-transform: none !important;
  font-weight: bold;
}
</style>
